module.exports = __webpack_public_path__ + "static/media/Machine_Tests_Marathi_mr.042b269a.jpg";